import Masonry from 'masonry-layout'
import imagesLoaded from 'imagesloaded'
export default {
  init() {},
  finalize() {
    const grid = document.querySelector(".grid");

    new imagesLoaded(grid, function (instance) {
      new Masonry(grid, {
        percentPosition: true,
      });
    });
  },
};